import { render, staticRenderFns } from "./add-alert.vue?vue&type=template&id=73ab4915&"
import script from "./add-alert.vue?vue&type=script&lang=js&"
export * from "./add-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports